import {
  ChangeDetectionStrategy,
  Component,
  input,
  viewChild,
} from '@angular/core';
import { Menu, MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { Params, RouterLink } from '@angular/router';
import { ItemActionSubmenuItemsPipe } from '../../pipes/item-action-submenu-items.pipe';
import { OnlyVisibleTableItemActionsPipe } from '../../pipes/only-visible-table-item-actions.pipe';
import { TableItemAction } from '../../models/table-item-action';
import { TableItemActionType } from '../../enums/table-item-action-type';
import { isNil, Nillable } from '@web/utils';
import { ButtonModule } from 'primeng/button';
import { IconComponent } from '../../../icon/components/icon/icon.component';
import { PrimengButtonDirective } from '../../../button/directives/primeng-button.directive';

@Component({
  selector: 'app-table-item-action',
  templateUrl: './table-item-action.component.html',
  styleUrls: ['./table-item-action.component.scss'],
  imports: [
    ButtonModule,
    TooltipModule,
    RouterLink,
    IconComponent,
    MenuModule,
    ItemActionSubmenuItemsPipe,
    OnlyVisibleTableItemActionsPipe,
    PrimengButtonDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableItemActionComponent<Item, Action> {
  public readonly action = input.required<TableItemAction<Item, Action>>();
  public readonly model = input.required<Item>();
  public readonly menu = viewChild.required(Menu);

  protected readonly TableItemActionType = TableItemActionType;

  public handleMoreClick(event: MouseEvent): void {
    this.menu().toggle(event);
  }

  public queryParams(): Nillable<Params> {
    const action = this.action();

    if (isNil(action.queryParams)) {
      return null;
    }

    return action.queryParams(this.model());
  }
}
